<script setup>

// 建设
const props = defineProps({
    maps: {
        type: Array,
        default: () => [],
    },
    common: {
        type: Object,
        required: false,
        default: () => { },
    }
})
</script>

<template>
    <div class="Heziyun-build Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('index.build1') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{ $t('index.build2') }}</p>
            </div>
            <div class="Heziyun-constructionContent">
                <div class="Heziyun-differentiation">

                    <div class="Heziyun-titleDescription">
                        <span >{{ $t('index.build3') }}</span>
                        <p >{{ $t('index.build4') }}</p>
                        <a href="/home.htm" class="Heziyun-lightSpeed" >
                            {{ $t('index.build5') }}
                            <img src="@/static/img/index/right.svg" alt="">
                        </a>

                        <div class="Heziyun-words">
                            <div class="Heziyun-item" v-intersect="{ class: 'bottom-top', delay: 0 }">
                                <span>{{ $t('index.build6') }}</span>
                                <p >
                                    {{ common?.map_param1 }}
                                </p>
                            </div>
                            <div class="Heziyun-item" v-intersect="{ class: 'bottom-top', delay: 50 }">
                                <span>{{ $t('index.build7') }}</span>
                                <p >
                                    {{ common?.map_param2 }}
                                </p>
                            </div>
                            <div class="Heziyun-item" v-intersect="{ class: 'bottom-top', delay: 100 }">
                                <span>{{ $t('index.build8') }}</span>
                                <p >
                                    {{ common?.map_param3 }}
                                </p>
                            </div>
                            <div class="Heziyun-item" v-intersect="{ class: 'bottom-top', delay: 150 }">
                                <span>{{ $t('index.build9') }}</span>
                                <p >
                                    {{ common?.map_param4 }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="Heziyun-map">
                        <img src="@/static/img/index/map.webp" alt="" v-intersect="{ class: 'opacity', delay: 300 }">
                        <div class="Heziyun-item" v-for="(item, index) in maps" :key="item.id"
                            :style="{ left: item.x + '%', top: item.y + '%' }"
                            v-intersect="{ class: 'opacity', delay: index * 100 }">
                            <div class="Heziyun-surround">
                                <div class="Heziyun-backs" :class="{
                                    'Heziyun-leftTop': item.position == 1,
                                    'Heziyun-rightTop': item.position == 2,
                                    'Heziyun-leftBottom': item.position == 3,
                                    'Heziyun-rightBottom': item.position == 4
                                }">
                                    <span>{{ item.title }}</span>
                                    <p>{{ item.tips }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="Heziyun-mark" v-intersect="{ class: 'right-left', delay: 0 }" v-if="common.animation_status == 1">
                    <div class="Heziyun-itemMark">
                        <img src="@/static/img/index/itemMark1.png" alt="">
                        <span>ISO 27001</span>
                    </div>
                    <div class="Heziyun-itemMark">
                        <img src="@/static/img/index/itemMark2.png" alt="">
                        <span>SOC 1 Type II</span>
                    </div>
                    <div class="Heziyun-itemMark">
                        <img src="@/static/img/index/itemMark3.png" alt="">
                        <span>等级保护认证</span>
                    </div>
                    <div class="Heziyun-itemMark">
                        <img src="@/static/img/index/itemMark4.png" alt="">
                        <span>可信云认证</span>
                    </div>
                    <div class="Heziyun-itemMark">
                        <img src="@/static/img/index/itemMark5.png" alt="">
                        <span>ISO 27001</span>
                    </div>
                    <div class="Heziyun-itemMark">
                        <img src="@/static/img/index/itemMark6.png" alt="">
                        <span>KISMS 认证</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
// 安全合规、高速稳定的基础设施建设
.Heziyun-build {
    background-color: #fff;
    position: relative;

    .Heziyun-defaultWidth {
        position: relative;
        z-index: 1;
        font-family: "思源黑";

        .Heziyun-constructionContent {
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            .Heziyun-differentiation {
                display: flex;

                .Heziyun-titleDescription {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    width: 25%;

                    span {
                        font-size: 1.88rem;
                        font-weight: bold;
                        color: #191919;
                    }

                    p {
                        color: #595959;
                        line-height: 1.7;
                    }

                    a {
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                        background: #0066FF;
                        color: #fff;
                        padding: 0.5rem 1rem;
                        position: relative;
                        overflow: hidden;
                        width: max-content;

                        &:hover {
                            opacity: 0.75;
                        }

                        img {
                            width: 0.7rem;
                            height: 0.7rem;
                        }
                    }

                    .Heziyun-words {
                        display: grid;
                        grid-template-columns: repeat(2, 1fr);
                        gap: 5rem 0;
                        margin-top: 2rem;

                        .Heziyun-item {
                            span {
                                color: #494949;
                                font-size: 0.8rem;
                            }

                            p {
                                color: #191919;
                                font-size: 40px;
                                font-weight: 600;
                            }
                        }
                    }
                }

                .Heziyun-map {
                    width: 75%;
                    position: relative;

                    img {
                        width: 100%;
                    }

                    .Heziyun-item {
                        position: absolute;
                        width: 10px;
                        height: 10px;
                        background: #165dff;
                        box-shadow: 0 0 7px 1px #c8c8c8;
                        border-radius: 8px;
                        opacity: 1;
                        border: 1.5px solid #fff;
                        z-index: 1;
                        cursor: pointer;

                        &::after {
                            content: "";
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            background-color: #fff;
                            width: 50%;
                            height: 50%;
                            border-radius: 50%;
                            -webkit-border-radius: 50%;
                            -moz-border-radius: 50%;
                            -ms-border-radius: 50%;
                            -o-border-radius: 50%;
                            filter: blur(1px);
                        }

                        @keyframes twinkle {
                            0% {
                                -webkit-transform: scale(0);
                                opacity: .05;
                            }

                            20% {
                                -webkit-transform: scale(.5);
                                opacity: .1;
                            }

                            40% {
                                -webkit-transform: scale(1);
                                opacity: .2;
                            }

                            60% {
                                -webkit-transform: scale(1.5);
                                opacity: .3;
                            }

                            100% {
                                -webkit-transform: scale(2);
                                opacity: 0;
                            }
                        }

                        &::before {
                            content: "";
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            display: block;
                            height: 20px;
                            width: 20px;
                            margin: -10px 0 0 -10px;
                            animation: twinkle 2s linear infinite;
                            background-color: #4679ff;
                            border-radius: 100%;
                        }

                        &:hover {
                            z-index: 2;

                            .Heziyun-surround {
                                .Heziyun-backs {
                                    span {
                                        font-weight: bold;
                                    }

                                    p {
                                        display: block;
                                    }
                                }
                            }
                        }

                        .Heziyun-surround {
                            position: relative;
                            height: -webkit-fill-available;

                            .Heziyun-backs {
                                background: hsla(0, 0%, 100%, .9);
                                -webkit-box-shadow: 0 10px 21px 0 rgba(91, 116, 148, .17);
                                box-shadow: 0 10px 21px 0 rgba(91, 116, 148, .17);
                                display: inline-block;
                                opacity: .9;
                                padding: 5px 10px;
                                position: relative;
                                white-space: nowrap;
                                display: flex;
                                flex-direction: column;

                                span {
                                    font-size: 0.6rem;
                                    color: #191919;
                                }

                                p {
                                    display: none;
                                    font-size: 0.5rem;
                                }
                            }

                            .Heziyun-rightTop {
                                position: absolute;
                                left: 50%;
                                bottom: 50%;
                                border-radius: 5px 5px 5px 0;
                                -webkit-border-radius: 5px 5px 5px 0;
                                -moz-border-radius: 5px 5px 5px 0;
                                -ms-border-radius: 5px 5px 5px 0;
                                -o-border-radius: 5px 5px 5px 0;
                            }

                            .Heziyun-rightBottom {
                                position: absolute;
                                left: 50%;
                                top: 50%;
                                border-radius: 0 5px 5px 5px;
                                -webkit-border-radius: 0 5px 5px 5px;
                                -moz-border-radius: 0 5px 5px 5px;
                                -ms-border-radius: 0 5px 5px 5px;
                                -o-border-radius: 0 5px 5px 5px;
                            }

                            .Heziyun-leftTop {
                                position: absolute;
                                right: 50%;
                                bottom: 50%;
                                border-radius: 5px 5px 0 5px;
                                -webkit-border-radius: 5px 5px 0 5px;
                                -moz-border-radius: 5px 5px 0 5px;
                                -ms-border-radius: 5px 5px 0 5px;
                                -o-border-radius: 5px 5px 0 5px;
                            }

                            .Heziyun-leftBottom {
                                position: absolute;
                                right: 50%;
                                top: 50%;
                                border-radius: 5px 0 5px 5px;
                                -webkit-border-radius: 5px 0 5px 5px;
                                -moz-border-radius: 5px 0 5px 5px;
                                -ms-border-radius: 5px 0 5px 5px;
                                -o-border-radius: 5px 0 5px 5px;
                            }
                        }

                    }
                }
            }


            .Heziyun-mark {
                display: flex;
                align-items: center;
                justify-content: space-around;
                gap: 1rem 2rem;
                padding: 1rem;
                border-radius: 0.5rem;
                background-image: linear-gradient(0deg, #fff, #f3f5f8);
                border: 2px solid #fff;
                box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);

                .Heziyun-itemMark {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 0.5rem;
                    cursor: pointer;
                    filter: drop-shadow(2px 2px 14px #fff);
                    -webkit-filter: drop-shadow(2px 2px 1.5rem #fff);

                    &:hover {
                        span {
                            color: #0056ff;
                        }

                        img {
                            background-image: linear-gradient(0deg, #fff, #e0e0e0);
                        }
                    }

                    img {
                        width: 4rem;
                        height: 4rem;
                        object-fit: contain;
                        border-radius: 50%;
                        padding: 0.5rem;
                        transition: all 0.3s ease;
                        -webkit-transition: all 0.3s ease;
                        -moz-transition: all 0.3s ease;
                        -ms-transition: all 0.3s ease;
                        -o-transition: all 0.3s ease;
                        background-image: linear-gradient(180deg, #f3f5f8, #fff);
                        border: 2px solid #fff;
                        box-shadow: 8px 8px 20px rgba(55, 99, 170, .1), -8px -8px 20px #fff;
                    }

                    span {
                        color: #6d6d6d;
                        font-size: 0.8rem;
                    }

                }
            }
        }

    }
}

// 安全合规、高速稳定的基础设施建设
@media (max-width: 768px) {
    .Heziyun-build {

        .Heziyun-defaultWidth {

            .Heziyun-constructionContent {
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                gap: 7vw;

                .Heziyun-differentiation {
                    flex-direction: column-reverse;

                    .Heziyun-titleDescription {
                        gap: 3vw;
                        width: 100%;

                        span {
                            font-size: 4.5vw;
                        }

                        p {
                            font-size: 3.5vw;
                        }

                        a {
                            padding: 2vw 4vw;
                            gap: 1vw;
                            font-size: 3.5vw;

                            img {
                                width: 4vw;
                                height: 4vw;
                            }
                        }

                        .Heziyun-words {
                            gap: 4vw;

                            .Heziyun-item {
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                align-items: center;

                                span {
                                    font-size: 3.5vw;
                                }

                                p {
                                    font-size: 7.5vw;
                                }
                            }
                        }
                    }

                    .Heziyun-map {
                        width: 100%;

                        .Heziyun-item {
                            width: 2vw;
                            height: 2vw;

                            &::before {
                                display: none;
                            }

                            .Heziyun-surround {
                                .Heziyun-backs {
                                    display: none;
                                }
                            }
                        }
                    }

                }

                .Heziyun-mark {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 2vw;
                    padding: 4vw;
                    border-radius: 2vw;

                    .Heziyun-itemMark {
                        gap: 2vw;
                        filter: inherit;
                        -webkit-filter: inherit;

                        img {
                            width: 12vw;
                            height: 12vw;
                            border: 1vw solid #e5e8ed;
                            border-radius: 50%;
                            padding: 0.5vw;
                        }

                        span {
                            font-size: 4vw;
                        }

                        p {
                            font-size: 3vw;
                        }
                    }
                }


            }

        }
    }
}
</style>